module.exports = __webpack_public_path__ + "static/media/tfaSpinner.b832be75.gif";